import AxiosService from '@/Services/AxiosService';
import LoaderService from '@/Services/LoaderService';
import { Inject, Service } from 'vue-di-container';
import { AddUpdateRequestModel } from './NewUpdateRequestModels';

@Service()
export default class NewUpdateRequestService {
    @Inject(AxiosService) public axiosService!: AxiosService;
    @Inject(LoaderService) public loaderService!: LoaderService;

    public async LookupPaidSenders(customerType: number, crNumber: string, enterpriseUnifiedNumber: string): Promise<any> {
        this.loaderService.ShowLoader();
        try {
            const url = window.$config.HostName + 'api/update-requests/lookup-paid-senders';
            const result = await this.axiosService.axiosInstance.get(url, {
                params: {
                    customerType: customerType,
                    crNumber: crNumber,
                    enterpriseUnifiedNumber: enterpriseUnifiedNumber,
                },
            });
            this.loaderService.HideLoader();
            return result.data;
        } catch (exception) {
            this.loaderService.HideLoader();
            return false;
        }
    }

    public async AddRequest(model: AddUpdateRequestModel): Promise<any> {
        this.loaderService.ShowLoader();
        try {
            const url = window.$config.HostName + 'api/update-requests';
            const result = await this.axiosService.axiosInstance.post(url, model);
            this.loaderService.HideLoader();
            return result.data;
        } catch (exception) {
            this.loaderService.HideLoader();
            return false;
        }
    }

    public async GetSenderRequestFileContent(id: string): Promise<string> {
        this.loaderService.ShowLoader();
        try {
            const url = window.$config.HostName + 'api/sender-requests/attachments/' + id;
            const result = await this.axiosService.axiosInstance.get(url);
            this.loaderService.HideLoader();
            if (result.data && result.data.isSuccess && result.data.result) {
                return result.data.result;
            }
            return '';
        } catch (exception) {
            this.loaderService.HideLoader();
            return '';
        }
    }
}
